import { render, staticRenderFns } from "./StanNotification.vue?vue&type=template&id=49a25ccf&scoped=true"
import script from "./StanNotification.vue?vue&type=script&lang=js"
export * from "./StanNotification.vue?vue&type=script&lang=js"
import style0 from "./StanNotification.vue?vue&type=style&index=0&id=49a25ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a25ccf",
  null
  
)

export default component.exports